// extracted by mini-css-extract-plugin
export default {"hideScrollBar":"TKD93","dragRailOuterContainer":"ktIbh","dragRailInnerContainer":"_5ub+j","grabbing":"OQfvn"};